"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carryForwardFromResource = void 0;
/** Reads the stored carry-forward trail, or undefined when the resource has none (or a malformed one). */
const carryForwardFromResource = (value) => {
    if (!value || typeof value !== 'object') {
        return undefined;
    }
    const record = value;
    if (typeof record.fromResourceId !== 'string' || typeof record.fromVersion !== 'number') {
        return undefined;
    }
    return Object.assign({ fromResourceId: record.fromResourceId, fromVersion: record.fromVersion, fromName: typeof record.fromName === 'string' ? record.fromName : '', carriedAt: typeof record.carriedAt === 'string' ? record.carriedAt : '', placementsConfirmed: Boolean(record.placementsConfirmed) }, (record.failed === true ? { failed: true } : {}));
};
exports.carryForwardFromResource = carryForwardFromResource;
//# sourceMappingURL=carry_forward.js.map